export default {
    lang: {
        name: 'Want to buy'
    }
}